export default __webpack_public_path__ + "static/media/america_achievement.6cabd83e.png";